module.exports = __webpack_public_path__ + "media/images/front/programs/icon-person-active-247b480aa8096006315167bbad9d89e5.svg";